import React, { FC } from 'react';
import cn from 'classnames';

import { TProps } from './models';

export const Hr: FC<TProps> = ({
    className,
    height = 1,
    marginBottom,
    marginTop,
    styles,
    theme = 'white',
    width,
    ...rest
}) => (
    <hr
        {...rest}
        // @ts-ignore
        className={cn(styles.hr, styles[`${theme}Theme`], className)}
        style={{
            marginBottom,
            marginTop,
            height,
            width,
        }}
    />
);
